import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import backgroundImage from '../../assets/Images/background.jpeg';
import '../../styles/Restoration.css';

const Restoration: React.FC = () => {
  const { t } = useTranslation();
  const services = t('restorationPage.services', { returnObjects: true }) as Array<any>;
  const process = t('restorationPage.process', { returnObjects: true }) as Array<any>;

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <motion.section 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="restoration-hero"
      >
        <div className="absolute inset-0 bg-black/50 z-10" />
        <div className="absolute inset-0" style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }} />
        <div className="relative z-20 text-center text-white px-4">
          <motion.h1 
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="restoration-hero-title"
          >
            {t('restorationPage.heroTitle')}
          </motion.h1>
          <motion.p 
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="restoration-hero-subtitle"
          >
            {t('restorationPage.heroSubtitle')}
          </motion.p>
        </div>
      </motion.section>

      {/* Services Section */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="restoration-services">
            {services.map((service, index) => (
              <motion.div
                key={index}
                initial={{ y: 20, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ delay: index * 0.2 }}
                className="restoration-service-card"
              >
                <div className="restoration-service-icon">{service.icon}</div>
                <h3 className="restoration-service-title">{service.title}</h3>
                <p className="restoration-service-desc">{service.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <h2 className="restoration-process-title">{t('restorationPage.processTitle')}</h2>
          <div>
            {process.map((step, index) => (
              <motion.div
                key={index}
                initial={{ x: -20, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{ delay: index * 0.2 }}
                className="restoration-process-step"
              >
                <div className="restoration-step-number">
                  {step.step}
                </div>
                <div className="restoration-step-content">
                  <h3 className="restoration-step-title">{step.title}</h3>
                  <p className="restoration-step-desc">{step.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="restoration-cta-section">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="restoration-cta-title">{t('restorationPage.ctaTitle')}</h2>
          <p className="restoration-cta-desc">{t('restorationPage.ctaDesc')}</p>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="restoration-cta-btn"
          >
            {t('restorationPage.ctaButton')}
          </motion.button>
        </div>
      </section>
    </div>
  );
};

export default Restoration; 